export default "__VITE_ASSET__BAN6j8FS__"